export const InformationFields = [
  {
    label: "Product Name",
    value: "name",
    type: "text",
    placeholder: "Enter Product Name",
    required: true,
  },
  {
    label: "Brand Name",
    value: "brandName",
    type: "text",
    placeholder: "Enter Brand Name",
    required: true,
  },
  {
    label: "Category",
    value: "categoryId",
    type: "select",
    placeholder: "Select Category",
    required: true,
  },
  {
    label: "Type",
    value: "type",
    type: "dropdown",
    placeholder: "Select Product Type",
    options: [
      { label: "Colored Products", value: "C" },
      { label: "Dual Colored Products", value: "DC" },
      { label: "Named Variants", value: "NV" },
      { label: "Unquantifiable Products", value: "UP" },
    ],
    required: true,
  },
  {
    label: "Sort ID",
    value: "sortId",
    type: "number",
    placeholder: "Enter Sort ID",
    required: true,
  },
  {
    label: "Availability",
    value: "availability",
    type: "toggle",
    placeholder: "Select Availability",
    required: true,
  },
  {
    label: "Customization",
    value: "customization",
    type: "toggle",
    placeholder: "Select Customization",
    required: true,
  },
];

export const DetailsFields = [
  {
    label: "Description",
    value: "description",
    type: "textarea",
    placeholder: "Enter Description",
    required: true,
  },
  {
    label: "Item Details",
    value: "itemDetails",
    type: "list",
    placeholder: "Add item details",
  },
];

export const PricingFields = [
  {
    label: "MRP",
    value: "mrp",
    type: "currency",
    placeholder: "Enter MRP",
    required: true,
  },
  {
    label: "Margin",
    value: "discount",
    type: "number",
    placeholder: "Enter Discount",
    required: true,
    suffix: "%",
  },
  {
    label: "Final Cost",
    value: "cost",
    type: "currency",
    placeholder: "Enter Final Cost",
    required: true,
  },
];
